"use client";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface VerificationCodeInputProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  ariaLabel: string;
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
}

const VERIFICATION_CODE_LENGTH = 6;

/** Native numeric verification input with browser OTP autofill support. */
export function VerificationCodeInput({
  id,
  value,
  onChange,
  ariaLabel,
  disabled,
  autoFocus,
  className,
}: VerificationCodeInputProps) {
  const code = value.replace(/\D/g, "").slice(0, VERIFICATION_CODE_LENGTH);

  return (
    <Input
      id={id}
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      autoComplete="one-time-code"
      autoFocus={autoFocus}
      maxLength={VERIFICATION_CODE_LENGTH}
      value={code}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        "mx-auto h-12 max-w-xs text-center text-lg font-semibold tracking-[0.5em] tabular-nums",
        className,
      )}
      onChange={(event) =>
        onChange(event.currentTarget.value.replace(/\D/g, "").slice(0, VERIFICATION_CODE_LENGTH))
      }
    />
  );
}
